import { render, staticRenderFns } from "./my-card.vue?vue&type=template&id=a362d29c&"
import script from "./my-card.vue?vue&type=script&lang=js&"
export * from "./my-card.vue?vue&type=script&lang=js&"
import style0 from "./my-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports